import { DESIGN_TOKENS } from '@disqotech/vinyl-design-system/design-tokens';
import { DEVICE_BREAKPOINT,PARAGRAPH, TITLES_NORMAL } from 'Shared/styles/designConstants';
import styled from 'styled-components';

type MenuLinkContainerType = {
  isActive: boolean
}

export const MenuLinkContainer = styled.a<MenuLinkContainerType>`
  ${PARAGRAPH.DEFAULT}
  background-color: ${ props => props.isActive ?
    DESIGN_TOKENS.color.background.success.light.value :
    DESIGN_TOKENS.color.background.primary.value
  };

  padding      : 12px 32px 12px 24px;
  display      : block;
  border-radius: 100px;
  position     : relative;
  margin-top   : 8px;
  word-break   : break-word;
  cursor       : pointer;

  svg {
    position  : absolute;
    width     : 24px;
    height    : 24px;
    color     : ${ DESIGN_TOKENS.color.text.normal.value };
    right     : 5px;
    top       : 50%;
    margin-top: -12px;
    display   : none;

    @media ${DEVICE_BREAKPOINT.maxMobile} {
      right  : 10px;
      display: block;
    }
  }

  @media ${DEVICE_BREAKPOINT.maxMobile} {
    background-color: ${ DESIGN_TOKENS.color.background.primary.value };
  }
`;

export const MenuItemContainer = styled.div`
  ${PARAGRAPH.DEFAULT}
  padding      : 12px 32px 12px 24px;
  display      : block;
  border-radius: 100px;
  position     : relative;
  margin-top   : 8px;
  word-break   : break-word;

  svg {
    position  : absolute;
    width     : 24px;
    height    : 24px;
    color     : ${ DESIGN_TOKENS.color.text.normal.value };
    right     : 5px;
    top       : 50%;
    margin-top: -12px;
  }
`;

export const MenuText = styled.span`
  color  : ${ DESIGN_TOKENS.color.text.normal.value };
  display: block;
`;

export const MenuHeader = styled.span`
  ${ TITLES_NORMAL.FT_01 }
  color  : ${ DESIGN_TOKENS.color.text.normal.value };
  display: block;
`;

export const MenuSubtitle = styled.span`
  color  : ${ DESIGN_TOKENS.color.text.secondary.value };
  display: block;
`;